export default "__VITE_ASSET__Bu3g7bKr__"